import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';

export default ({ sx }: { sx?: SxProps<Theme> }) => (
  <Stack sx={sx}>
    <Skeleton variant="text" height={53} />
    <Divider />
  </Stack>
);
